{
  "program": [
    {
      "programTypeGuid": "D972DA85-0565-4971-B031-FC44878C6EA9",
      "element": [
        {
          "id": "engagementRegistrationIds",
          "displayName": "Event IDs"
        },
        {
          "id": "noOfEngagement",
          "displayName": "No of Event"
        }
      ],
      "exportHeaders": [
        { "id": "PaymentBatchName", "displayName": "PaymentBatchName" },
        {
          "id": "PaymentBatchScheduleDate",
          "displayName": "PaymentBatchScheduleDate"
        },
        {
          "id": "AnticipatedPaymentDate",
          "displayName": "AnticipatedPaymentDate"
        },
        {
          "id": "ActualPaymentCentralDate",
          "displayName": "ActualPaymentCentralDate"
        },
        { "id": "TotalAmount", "displayName": "TotalAmount" },
        { "id": "EventIds", "displayName": "EventIds" },
        { "id": "NoOfEvents", "displayName": "NoOfEvents" },
        { "id": "PartnersPaid", "displayName": "PartnersPaid" }
      ],
      "fileName": [
        { "id": 1, "displayName": "EventPaymentSchedule(Milestone1)" },
        { "id": 2, "displayName": "EventPaymentSchedule(Milestone2)" }
      ]
    },
    {
      "programTypeGuid": "C5D3A897-C737-4EEC-BFC7-D9FF1FB7F315",
      "element": [
        {
          "id": "engagementRegistrationIds",
          "displayName": "Engagement IDs"
        },
        {
          "id": "noOfEngagement",
          "displayName": "No of Engagements"
        }
      ],
      "exportHeaders": [
        { "id": "PaymentBatchName", "displayName": "PaymentBatchName" },
        {
          "id": "PaymentBatchScheduleDate",
          "displayName": "PaymentBatchScheduleDate"
        },
        {
          "id": "AnticipatedPaymentDate",
          "displayName": "AnticipatedPaymentDate"
        },
        {
          "id": "ActualPaymentCentralDate",
          "displayName": "ActualPaymentCentralDate"
        },
        { "id": "TotalAmount", "displayName": "TotalAmount" },
        { "id": "NoOfEvents", "displayName": "NoOfEngagements" },
        { "id": "PartnersPaid", "displayName": "PartnersPaid" }
      ],
      "fileName": [
        { "id": 1, "displayName": "MRPPPaymentSchedule(Milestone1)" },
        { "id": 2, "displayName": "MRPPPaymentSchedule(Milestone2)" }
      ]
    }
  ]
}
